import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { API } from '../App';
import { Loader2 } from 'lucide-react';

export default function AuthCallback({ auth }) {
  const navigate = useNavigate();
  const { login } = auth;
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      // Extract session_id from URL fragment
      const hash = window.location.hash;
      const sessionIdMatch = hash.match(/session_id=([^&]+)/);
      
      if (!sessionIdMatch) {
        console.error('No session_id found');
        navigate('/login', { replace: true });
        return;
      }

      const sessionId = sessionIdMatch[1];

      try {
        // Exchange session_id for user data
        const response = await fetch(`${API}/auth/google/session`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ session_id: sessionId }),
          credentials: 'include'
        });

        if (!response.ok) {
          throw new Error('Failed to process session');
        }

        const userData = await response.json();
        login(userData);

        // Clear hash and redirect to appropriate dashboard
        window.history.replaceState(null, '', window.location.pathname);
        
        const dashboards = {
          admin: '/admin',
          company: '/company',
          association: '/association',
          ecommerce: '/ecommerce',
          employee: '/employee'
        };
        
        // If user needs to select role (new Google user)
        if (!userData.company_name && userData.role === 'company') {
          navigate('/select-role', { replace: true, state: { user: userData } });
        } else {
          navigate(dashboards[userData.role] || '/employee', { replace: true, state: { user: userData } });
        }
      } catch (error) {
        console.error('Auth callback error:', error);
        navigate('/login', { replace: true });
      }
    };

    processAuth();
  }, [login, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-stone-100">
      <div className="flex flex-col items-center gap-4">
        <div className="w-12 h-12 border-4 border-emerald-800 border-t-transparent rounded-full animate-spin"></div>
        <p className="text-slate-600 font-medium">Connexion en cours...</p>
      </div>
    </div>
  );
}
